import { debounce } from './custom-modules';
window.debounce = debounce;

import { setCookie } from "./custom-modules";
window.setCookie = setCookie;

import { getCookie } from "./custom-modules";
window.getCookie = getCookie;

import { scroll_to } from "./custom-modules";
window.scroll_to = scroll_to;

import { formatMoney } from "./custom-modules";
window.formatMoney = formatMoney;

import { isFullyInViewport } from "./custom-modules";
window.isFullyInViewport = isFullyInViewport;

import { isPartiallyInViewport } from "./custom-modules";
window.isPartiallyInViewport = isPartiallyInViewport;

